import React, { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";

const NavigationButton = ({ onHandleDrawer, isSticky, isDown, isVisible }) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024); // 1024px is the 'lg' breakpoint in Tailwind
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleClick = () => {
    if (!isLargeScreen) {
      onHandleDrawer();
    }
  };

  const handleMouseEnter = () => {
    if (isLargeScreen && !isVisible) {
      onHandleDrawer({ type: "enter", target: "button" });
    }
  };

  return (
    <div className="ml-auto xsl:hidden">
      <button
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        className="relative"
      >
        <div
          className={`flex items-center w-full flex-col gap-y-2 mt-1 ${
            isSticky || isDown ? "text-3xl" : "text-4xl"
          } `}
        >
          {isVisible ? <X /> : <List />}
        </div>
      </button>
    </div>
  );
};

export default NavigationButton;
